import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { SidenavBottomPanelInfoComponent } from '../../../../../../../../shared/components/sidenav/sidenav-bottom-panel-info/sidenav-bottom-panel-info.component';
import { AuthFlowService } from '../../../../../../../../core/services/auth-wrapper/auth-flow.service';

@Component({
    selector: 'app-go-sidenav-bottom-panel',
    imports: [MatButtonModule, RouterModule, SidenavBottomPanelInfoComponent],
    templateUrl: './go-sidenav-bottom-panel.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './go-sidenav-bottom-panel.component.scss',
})
export class GoSidenavBottomPanelComponent {
    @Input() isCollapsed!: boolean;

    constructor(private readonly authFlowService: AuthFlowService) {}

    logout() {
        this.authFlowService.logout();
    }
}
